const state = {

    data() {
        return {

        }
    },
    methods: {
        getState(state) {
            const states = {
                enviado: "btn-primary",
                emAnalise: "btn-warning",
                valido: "btn-success",
                liberado: "btn-success",
                recusado: "btn-danger",
                bloqueado: "btn-danger",
            };
            return states[state] || "btn-primary";
        },
        getIcon(state) {
            const states = {
                enviado: "fa-send",
                emAnalise: "fa-hourglass-start",
                valido: "fa-check",
                liberado: "fa-check",
                recusado: "fa-times",
                bloqueado: "fa-times",
            };

            return states[state] || "fa-cogs";
        },
        getAlert(state){
            const states = {
                enviado: "alert-primary",
                send: "alert-primary",
                emAnalise: "alert-warning",
                valido: "alert-success",
                liberado: "alert-success",
                recusado: "alert-danger",
                bloqueado: "alert-danger",
            };
            return states[state] || "alert-primary";
        }
    }
}

export default state


// WEBPACK FOOTER //
// ./src/mixins/state.js